// extracted by mini-css-extract-plugin
module.exports = {"Link":"Account_Link__1NX3G","pending":"Account_pending__1rEyI","purchaseContainer":"Account_purchaseContainer__2OqKG","tblPurchase":"Account_tblPurchase__7CU7m"};